import { render, staticRenderFns } from "./TpmsDialog.vue?vue&type=template&id=cab859c0"
import script from "./TpmsDialog.vue?vue&type=script&lang=js"
export * from "./TpmsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports